export const LS_EMAIL = 'email'
export const LS_PASSWORD = 'password'
export const LS_LANGUAGE = 'lang'
export const LS_REMEMBER_LOGIN = 'remember_login'
export const LS_USER_INFO = 'userInfo'
export const LS_POPUP_DASHBOARD = 'popup_dashboard'
export const LS_USER_ID = 'userID'
